import {useState} from "react";
import {Button} from "@/components/ui/button.tsx";
import {Popover, PopoverContent, PopoverTrigger} from "@/components/ui/popover.tsx";
import {UploadAudioFile} from "@/components/ui/UploadAudioFile.tsx";
import {AudioPlayer} from "@/components/ui/audio-player.tsx";
import {useGetStreamsFileQuery} from "@/store/streams-files.ts";
import {Spinner} from "@/components/ui/spinner.tsx";
import {XMarkIcon, MusicalNoteIcon} from "@heroicons/react/24/outline";

type AudioPickerFieldProps = {
    label: string;
    value: number | null | undefined;
    onChange: (id: number | null) => void;
};

export function AudioPickerField({label, value, onChange}: AudioPickerFieldProps) {
    const [open, setOpen] = useState(false);
    const {data: streamFile, isFetching} = useGetStreamsFileQuery(value as number, {skip: !value});

    return (
        <div className="space-y-1">
            <label className="text-xs font-medium text-neutral-600">{label}</label>
            <div className="flex items-center gap-2 rounded-lg border border-neutral-200 px-2 py-1.5 min-h-10">
                {!value && (
                    <span className="text-xs text-neutral-400 flex items-center gap-1">
                        <MusicalNoteIcon className="size-4"/> לא נבחר קובץ שמע
                    </span>
                )}

                {value && isFetching && <Spinner size="sm"/>}

                {value && streamFile?.audio_file && (
                    <AudioPlayer src={streamFile.audio_file} title={streamFile.name} simple/>
                )}

                <div className="flex-grow"/>

                {value && (
                    <Button type="button" variant="ghost" size="icon-xs" className="cursor-pointer"
                            onClick={() => onChange(null)}>
                        <XMarkIcon className="size-4 text-neutral-400"/>
                    </Button>
                )}

                <Popover open={open} onOpenChange={setOpen}>
                    <PopoverTrigger asChild>
                        <Button type="button" size="xs" variant="outline" className="cursor-pointer shrink-0">
                            {value ? 'החלף' : 'בחר / הקלט'}
                        </Button>
                    </PopoverTrigger>
                    <PopoverContent className="w-96" align="end">
                        <UploadAudioFile
                            title={label}
                            onChange={(id) => {
                                onChange(id);
                                setOpen(false);
                            }}
                        />
                    </PopoverContent>
                </Popover>
            </div>
        </div>
    );
}

